import io from "socket.io-client";
import { store } from "../store/store";
import { authorize } from "./auth";

const socket = io("/", {
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: 99999
});

/**
 * Listening for when connection has been established
 */
socket.on("connect", () => {
  store.commit("setSocketAuthorized", false);
  authorize();
  store.dispatch("chat/getRemaingMessages");
});

export default socket;
